// src/web/client/src/utils/storage.js
// יוטילס גלובלי לניהול localStorage

import { getShopDomain as resolveShopDomain } from './shopContext';

export const storage = {
    // Shop domain via THE shared resolver (utils/shopContext, priority-3):
    // URL ?shop= wins over storage, stale shop-scoped keys purged on switch,
    // null when honestly unknown (safeApi already skips the call on null).
    // This delegation lifts every storage.getShopDomain consumer (safeApi,
    // SubscriptionAlert, CouponGenerator, …) onto the single resolver.
    getShopDomain: () => resolveShopDomain(),
  

     
    // הגדר shop domain בכל המפתחות
    setShopDomain: (domain) => {
      if (domain && domain !== 'undefined') {
        localStorage.setItem('shop_domain', domain);
        localStorage.setItem('shopDomain', domain);
        sessionStorage.setItem('shop_domain', domain);
        sessionStorage.setItem('shopDomain', domain);
      }
    },

    
  
    // קבל shop ID. No demo-id fallback (same data-integrity rule as
    // getShopDomain) — unknown shop returns null.
    getShopId: () => {
      const id =
        localStorage.getItem('shop_id') ||
        localStorage.getItem('shopId');

      if (!id || id === 'undefined' || id === 'null') {
        return null;
      }

      return id;
    },
  
    // הגדר shop ID
    setShopId: (id) => {
      if (id && id !== 'undefined') {
        localStorage.setItem('shop_id', id);
        localStorage.setItem('shopId', id);
      }
    },
  
    // נקה כל הנתונים
    clearShopData: () => {
      const keysToRemove = ['shop_domain', 'shopDomain', 'shop_id', 'shopId', 'shopName'];
      keysToRemove.forEach(key => {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
      });
    },
  
    // בדוק אם יש נתוני חנות תקינים
    hasValidShopData: () => {
      const domain = storage.getShopDomain();
      return domain && domain !== 'undefined' && domain !== 'null';
    }
  };